import { getRandomIntInclusive } from '@application/utils';
import { InputLabel, InputWrapper, SkeletonBox } from '@presentation/components';
import { Fragment } from 'react';
import * as RootStyled from '../../styled';

export const PageSkeleton = () => {
  return (
    <>
      <InputWrapper>
        <InputWrapper split>
          <InputLabel>
            <SkeletonBox style={{ width: `${getRandomIntInclusive(30, 40)}%`, height: 15 }} />
          </InputLabel>
          <RootStyled.ImageWrapperContainer>
            <RootStyled.ImageWrapper>
              <SkeletonBox style={{ width: `${getRandomIntInclusive(50, 90)}%`, height: 200 }} />
            </RootStyled.ImageWrapper>
          </RootStyled.ImageWrapperContainer>
        </InputWrapper>
      </InputWrapper>

      {Array.from(Array(10).keys()).map((index) => (
        <Fragment key={index}>
          <InputWrapper split last={index % 2 === 0}>
            <InputLabel>
              <SkeletonBox style={{ width: `${getRandomIntInclusive(30, 40)}%`, height: 15 }} />
            </InputLabel>
            <SkeletonBox style={{ width: `${getRandomIntInclusive(50, 90)}%`, height: 45 }} />
          </InputWrapper>
        </Fragment>
      ))}
    </>
  );
};
